import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import React from 'react';

function Drag(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 12 20" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 4a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm8-16a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
          fill="#5B6676"
          fillRule="nonzero"
        />
      </svg>
    </SvgIcon>
  );
}

export default Drag;
